import * as React from "react";
import { FormFieldContext } from "./form-contexts";

export function useFormField() {
  const context = React.useContext(FormFieldContext);
  if (!context) {
    throw new Error("useFormField must be used within a FormFieldContext.Provider");
  }
  return context;
}
